import {useQuery} from "@tanstack/react-query";

import {useStoredSession} from "@/src/modules/auth/store/session";

import {getMeQueryOptions} from "../lib/me-query";

export default function useMe() {
  const session = useStoredSession();

  const query = useQuery({
    ...getMeQueryOptions(),
    enabled: !!session,
  });

  return query;
}
